module.exports = __webpack_public_path__ + "img/667650a.jpg";